export default __webpack_public_path__ + "static/086-5961f27b4be627a1998df724caa7ebfe.jpg";